import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import ReactDOM from 'react-dom';
import {useracc, postApi} from '../utils/functions';
import axios from 'axios';
import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';

import FacebookLogin from 'react-facebook-login';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import './css/login.css';

export default class Login extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			return: this.props.return,
			password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
			},
			linkaccount: {},
		};
		this.showPassword = this.showPassword.bind(this);
		this.responseFacebook = this.responseFacebook.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.submitPassword = this.submitPassword.bind(this);
  };

  
  
  async componentDidMount() {
		document.title = "Login - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});
	}

	getUser = (e) => {
    this.setState({await: true});
    e.preventDefault();
    const params = new URLSearchParams();
    params.append('username', e.target.elements.username.value);
    params.append('password', e.target.elements.password.value);
    params.append('remember', e.target.elements.remember.checked);
    params.append('cookie', localStorage.getItem('cookie'));
    if(this.state.totp === true)
    params.append('totp', e.target.elements.totp.value);
    axios.post(`/api/v1/login`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    })
    .then((res) => {
      if( res.data.error ) {
        if( res.data.error === "Recover" ) {
          window.location.href = '/recover';  
        } else {
          const element = res.data.error;
          ReactDOM.render( element, document.getElementById('error') );
          this.setState({await: false, totp: false});
        }
      } else {
        //EventEmitter.emit('/syncerror', {show: false});
				EventEmitter.emit('/socket/reconnect', {data: 'no value'});
				/*try{ 
        	this.props.history.push('/');
				} catch(error) {
					window.location.href = '/mchat';
				}*/
				window.location.href = `/${this.state.return}`;
      }
    })
    .catch(error => {
      if (error.message === "Network Error"){
				//EventEmitter.emit('/syncerror', {show: true});
				setTimeout(_ => {
        	this.getUser(e);
      	}, 5000);
			}
      if( error.response.status === 403 ) {
        this.setState({await: false, totp: true});
      }
    });
  }

	componentWillUnmount() {
		
	}

	showPassword() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}

	async responseFacebook(response) {

		if( response.name && response.email && response.picture && response.accessToken ) {
			let params = new URLSearchParams();
			params.append('id', response.id);
			params.append('name', response.name);
			params.append('email', response.email);
			params.append('picture', response.picture);
			params.append('accessToken', response.accessToken);
			const x = await postApi('/api/v1/loginfacebook', params);
			if( x.status === 200 ) {
				window.location.href = `/${this.state.return}`;
			} else if( x.status === 210 ) {
				this.setState({linkaccount: response});
			}
		}

	}
	
	handleClose() {
		this.setState({linkaccount: {}});
	}

	submitPassword = async (e) => {
		e.preventDefault();

		let params = new URLSearchParams();
			params.append('id', this.state.linkaccount.id);
			params.append('name', this.state.linkaccount.name);
			params.append('email', this.state.linkaccount.email);
			params.append('picture', this.state.linkaccount.picture);
			params.append('accessToken', this.state.linkaccount.accessToken);
			params.append('password', e.target.elements.passwordmix365.value);
			const x = await postApi('/api/v1/loginfacebook', params);
			if( x.status === 200 ) {
				window.location.href = `/${this.state.return}`;
			}
	}

	render() {
		
		return (
			<>
				<div className="website-background"></div>
				<Container>
					<Row>
						<Col className="text-center pt-5 text-vcenter">
							<div>
								<img  src="/images/365_Logo.png" alt="Mix365 Logo" width="250" /><br />
								<span className="login-title">Login to your Mix365 Account</span>
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<Form id="contact-form" onSubmit={this.getUser}>

								<Row>
									<Col xs={12}>
										<div id="error" className="login-error"></div>
									</Col>
								</Row>
								<Row className="pt-3">
									<Col>
										<label htmlFor="username">Username</label>
									</Col>
									<Col xs={12}>
										<FormControl name="username" id="username" placeholder="Username" aria-label="Username" aria-describedby="Username" required />
									</Col>
								</Row>

								<Row className="pt-3">
									<Col>
										<label htmlFor="password">Password</label>
									</Col>
									<Col xs={12}>
										<InputGroup className="mb-2">
											<FormControl type={this.state.password.visible?'text':'password'} name="password" id="password" placeholder="Password" aria-label="Password" aria-describedby="Password" required />
											<InputGroup.Text className="login-password-show" onClick={this.showPassword}>
												<OverlayTrigger
													trigger={['hover']}
													placement="bottom"
													overlay={
														<Tooltip id="tooltip-replay">Click to show/hide your password</Tooltip>
													}      
												>
													<FontAwesomeIcon icon="eye" />
												</OverlayTrigger>
											</InputGroup.Text>
										</InputGroup>
									</Col>
								</Row>

								<Row className="pt-3">
									<Col xs={12}>
										<InputGroup className="mb-2">
											<Form.Check type="checkbox"  className="remember" name="remember" id="remember" />
											&nbsp;&nbsp;<label htmlFor="remember">Remember Me</label>
										</InputGroup>
									</Col>
								</Row>

								<Row className="pt-3">
									<Col xs={12}>
										<Button size="sm" type="submit" form="contact-form" className="login-form-button">Login</Button>&nbsp;&nbsp;
										{/*<FacebookLogin
											appId="777177023418156"
											autoLoad={false}
											fields="name,email,picture"
											callback={this.responseFacebook}
											cssClass="btn btn-primary btn-sm login-form-button"
											icon="fa-facebook"
										/>&nbsp;&nbsp;*/}
										<Link to={'/recover'}><Button size="sm" form="contact-form" className="login-form-button">Forgot Username Password</Button></Link>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				</Container>
				<Modal show={Object.keys(this.state.linkaccount).length>0?true:false} onHide={this.handleClose} backdrop="static" centered size="lg">
					<Form id="contact-form-2" onSubmit={(e)=>this.submitPassword(e)}>
						<Modal.Header closeButton className="bg-dark">
							<Modal.Title>Facebook Login</Modal.Title>
						</Modal.Header>
						<Modal.Body className="bg-dark">
							<Row>
								<Col xs={12}>
									There is an account associated with the email address {this.state.linkaccount.email}, please enter your Mix365 password to confirm your account.<br />* This is only required for the first time.<br /><br />Enter Mix365 Password:
								</Col>
								<Col xs={12}>
									<InputGroup className="mb-2">
										<FormControl type={this.state.password.visible?'text':'password'} name="passwordmix365" id="passwordmix365" placeholder="Password" aria-label="Password" aria-describedby="Password" required />
										<InputGroup.Text style={{background: 'rgba(144,144,144,0.07)', border: 'none', cursor: 'pointer'}} onClick={this.showPassword}>
											<FontAwesomeIcon icon="eye" />
										</InputGroup.Text>
									</InputGroup>
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer className="bg-dark">
							<Button variant="secondary" onClick={this.handleClose}>
								Close
							</Button>
							<Button variant="primary" form="contact-form-2" type="submit">
								Login
							</Button>
						</Modal.Footer>
					</Form>
				</Modal>
			</>
		);
	}
}
